import { Gift } from '@phosphor-icons/react';

export default Gift;
